import { useEffect } from 'react';
import '@/App.css';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Toaster } from '@/components/ui/sonner';
import { LiveProvider, useLive } from '@/lib/live';
import { StickyTopBar } from '@/components/journey/StickyTopBar';
import { TicketModal } from '@/components/journey/TicketModal';
import { S00Signal } from '@/components/journey/S00Signal';
import { S02Timetable } from '@/components/journey/S02Timetable';
import { S04Tunnel } from '@/components/journey/S04Tunnel';
import { S05LiveJourney } from '@/components/journey/S05LiveJourney';
import { S07Horizon } from '@/components/journey/S07Horizon';

gsap.registerPlugin(ScrollTrigger);

const QuietServiceChip = () => {
  const { reducedMotion } = useLive();
  if (!reducedMotion) return null;
  return (
    <div
      className="enamel fixed bottom-4 left-4 z-50 rounded-lg px-3 py-1.5 font-mono text-[10px] tracking-[0.2em] text-[#f3e7cf]/80"
      data-testid="quiet-service-chip"
    >
      QUIET SERVICE IS RUNNING.
    </div>
  );
};

const Journey = () => {
  useEffect(() => {
    // fast-scroll safety: recalc after images settle
    const t = setTimeout(() => ScrollTrigger.refresh(), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <main className="relative bg-[#0b0d10] text-[#f3e7cf]">
      <StickyTopBar />
      <S00Signal />
      <S02Timetable />
      <S04Tunnel />
      <S05LiveJourney />
      <S07Horizon />
      <TicketModal />
      <QuietServiceChip />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: 'rgba(11,13,16,0.92)',
            border: '1px solid rgba(255,255,255,0.14)',
            color: '#f3e7cf',
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: '12px',
            letterSpacing: '0.06em',
          },
        }}
      />
    </main>
  );
};

function App() {
  return (
    <LiveProvider>
      <Journey />
    </LiveProvider>
  );
}

export default App;
